// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@flip/App/SharedStyle/MyAccount/Details/MyAccountDetailsStyles";
import { rfqQuoteDetailsInformationStyles } from "@flip/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.expirationDateLabelText = {
    ...myAccountDetailsStyles.informationHeadingAndText?.heading,
};
rfqQuoteDetailsInformationStyles.jobNameHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
rfqQuoteDetailsInformationStyles.salesRepHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
rfqQuoteDetailsInformationStyles.userHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
rfqQuoteDetailsInformationStyles.statusHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
rfqQuoteDetailsInformationStyles.dateLabelText = {
    ...myAccountDetailsStyles.informationHeadingAndText?.heading,
};
rfqQuoteDetailsInformationStyles.customerHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
// XNG-Changes
rfqQuoteDetailsInformationStyles.customerNumberHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
rfqQuoteDetailsInformationStyles.shipToHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};
rfqQuoteDetailsInformationStyles.notesHeadingAndText = {
    ...myAccountDetailsStyles.informationHeadingAndText,
};

// XNG-Changes: Grid Items
rfqQuoteDetailsInformationStyles.salesRepGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
rfqQuoteDetailsInformationStyles.userGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
rfqQuoteDetailsInformationStyles.statusGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
rfqQuoteDetailsInformationStyles.shipToGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
rfqQuoteDetailsInformationStyles.customerGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
rfqQuoteDetailsInformationStyles.customerNumberGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
rfqQuoteDetailsInformationStyles.expirationDateGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        p {
            font-size: 14px;
            line-height: 22px;
        }
        ${TypographyStyle} {
            > div {
                font-size: 16px;
                font-weight: 700;
                line-height: 22px;
                @media print {
                    font-size: 12px;
                }
                margin-bottom: 5px;
            }
        }
    `,
};
rfqQuoteDetailsInformationStyles.dateGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        p {
            font-size: 14px;
            line-height: 22px;
        }
    `,
};
